export const permissionChartLink =
    'https://explore.voxie.com/voxiesupport/hc/en-us/articles/groups-franchise-hub-lifecycle-management-toolset';
